<template>
  <v-layout align-center wrap>
    <v-flex xs2>
      <h3 class="subheading grey--text text--darken-2">ブランド名（任意）</h3>
    </v-flex>
    <v-flex xs10>
      <SearchAndSelect
        :loading="loading"
        :searched-list="searchedList"
        :selected-item="defaultBrand"
        :disabled="disabled"
        @search="getList"
        @change="selectItem"
        modal-title="ブランド名検索"
        can-not-search-when-blank-keyword
        button-text="ブランド名を検索"
      />
    </v-flex>
    <v-flex xs12>
      <span style="font-weight: 300;">
        ブランド名を英語で検索の上選択して下さい。
        <br />※
        ブランド名を入力していただいた方がクリエイティブの審査が早くなります。
      </span>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import SearchAndSelect from '@/components/Shared/CrudUI/SearchAndSelect'
export default {
  components: { SearchAndSelect },
  props: {
    defaultBrand: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      searchKeyword: '',
      selectedItemName: this.defaultBrand.name,
      loading: false,
    }
  },
  watch: {
    disabled() {
      this.selectedItemName = ''
    },
  },
  computed: {
    ...mapState({
      brandList: state => state.master.brandList,
    }),
    searchedList() {
      return this.brandList
    },
  },
  mounted() {
    this.$store.dispatch('master/CLEAR_BRAND_LIST')
  },
  methods: {
    async getList(keyword) {
      this.loading = true
      this.$store.dispatch('master/CLEAR_BRAND_LIST')
      try {
        // 1ページ目しか表示されないので多めに取っておく
        await this.$store.dispatch('master/GET_BRAND_LIST', {
          pageNo: 1,
          pageSize: 100,
          name: keyword,
        })
      } catch (e) {
        this.loading = false
        const error = new Error('ブランドの取得に失敗しました。')
        throw error
      }
      this.loading = false
    },
    selectItem(item) {
      this.selectedItemName = item.name
      this.$emit('input', item)
    },
  },
}
</script>
